import { Component, Input } from '@angular/core';

import { PromoBannerStrip } from 'src/environments/environment.interface';

@Component({
  selector: 'df-promo-banner',
  templateUrl: './promo-banner.component.html',
  styleUrls: ['./promo-banner.component.scss']
})
export class PromoBannerComponent {
  @Input() banner: PromoBannerStrip | null;

  ngOnInit(): void {
    if(this.banner == null) {
      this.banner = {
        show: false,
        text: "",
        link: "",
        linkText: "",
        backgroundColor: "",
        textColor: "",
        showCloseButton: true
      }
    }
  }

  closeBanner() : void {
    // Remove the component from the DOM
    const element = document.getElementById('promoBanner');
    if (element) {
      element.remove();
    }
  }
}
